import React from 'react';
import classNames from 'classnames';
import { statusTimestampCheck } from '@gumtree/shared/src/util/date-helpers';

import SellerStatsBlock from './seller-stats-block';

import './seller-stats.scss';

const SellerStats = ({
    sellerStats: { postingSince },
    showRating = false,
    vipSellerInfo,
}: Props) => {
    const className = classNames('seller-stats-component seller-stats-newLayout', {
        'seller-stats-no-rating': !showRating,
    });

    return (
        <div className={className} data-testid="seller-stats-component">
            <SellerStatsBlock
                message="Posting for"
                value={postingSince}
                strong={false}
                className="newLayout"
            />
            {vipSellerInfo.lastActiveStatus && (
                <div className="seller-stats-active">
                    <span>|</span>
                    <div>{statusTimestampCheck(vipSellerInfo.lastActiveStatus)}</div>
                </div>
            )}
        </div>
    );
};

export interface Props {
    sellerStats: { postingSince: string }
    showRating: boolean,
    vipSellerInfo: {
        lastActiveStatus: string | null
    }
}

export default SellerStats;
